import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { SnackbarProvider } from 'notistack';
import theme from './theme/theme';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import EarningDashboardPage from './pages/EarningDashboardPage';
import DriverRechargeHistoryPage from './pages/DriverRechargeHistoryPage';
import DriversPage from './pages/DriversPage';
import DriverDocumentsPage from './pages/DriverDocumentsPage';
import PassengersPage from './pages/PassengersPage';
import RidesPage from './pages/RidesPage';
import VerificationsPage from './pages/VerificationsPage';
import DocumentsPage from './pages/DocumentsPage';
// Transactions and Withdrawals removed from menu (recharge model — driver
// collects cash directly). Re-enable by uncommenting these + the Route lines.
// import TransactionsPage from './pages/TransactionsPage';
// import WithdrawalsPage from './pages/WithdrawalsPage';
import PromoCodesPage from './pages/PromoCodesPage';
import PricingPage from './pages/PricingPage';
import NotificationsPage from './pages/NotificationsPage';
import ReportsPage from './pages/ReportsPage';
import EmergencyPage from './pages/EmergencyPage';
import LiveTrackingPage from './pages/LiveTrackingPage';
import RatingsPage from './pages/RatingsPage';
import SupportPage from './pages/SupportPage';
import RegionsPage from './pages/RegionsPage';
import MainServicesPage from './pages/MainServicesPage';
import ServicesPage from './pages/ServicesPage';
import CancelReasonsPage from './pages/CancelReasonsPage';
import RatingFeedbackPage from './pages/RatingFeedbackPage';
import ComplaintsPage from './pages/ComplaintsPage';
import AdminUsersPage from './pages/AdminUsersPage';
import SettingsPage from './pages/SettingsPage';
import FAQsPage from './pages/FAQsPage';
import LegalPagesPage from './pages/LegalPagesPage';
import RechargePlansPage from './pages/RechargePlansPage';
import NotificationHistoryPage from './pages/NotificationHistoryPage';
import EmergencyContactsPage from './pages/EmergencyContactsPage';
import QuickChatPage from './pages/QuickChatPage';
import ChatConversationsPage from './pages/ChatConversationsPage';
import OurServicesPage from './pages/OurServicesPage';
import DriverRatingPage from './pages/DriverRatingPage';
import PassengerRatingPage from './pages/PassengerRatingPage';

import TaxiAttachmentDashboardPage from './pages/TaxiAttachmentDashboardPage';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <AuthProvider>
          <Router>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <Layout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Navigate to="/dashboard" replace />} />
                <Route path="dashboard" element={<DashboardPage />} />
                <Route path="dashboard/earnings" element={<EarningDashboardPage />} />
                <Route path="dashboard/recharge-history" element={<DriverRechargeHistoryPage />} />
                <Route path="dashboard/taxi-attachment" element={<TaxiAttachmentDashboardPage />} />
                <Route path="drivers" element={<DriversPage />} />
                <Route path="driver-documents" element={<DriverDocumentsPage />} />
                <Route path="passengers" element={<PassengersPage />} />
                <Route path="rides" element={<RidesPage />} />
                <Route path="verifications" element={<VerificationsPage />} />
                <Route path="documents" element={<DocumentsPage />} />
                {/* <Route path="transactions" element={<TransactionsPage />} /> */}
                {/* <Route path="withdrawals" element={<WithdrawalsPage />} /> */}
                <Route path="promo-codes" element={<PromoCodesPage />} />
                <Route path="pricing" element={<PricingPage />} />
                <Route path="notifications" element={<NotificationsPage />} />
                <Route path="notification-history" element={<NotificationHistoryPage />} />
                <Route path="emergency-contacts" element={<EmergencyContactsPage />} />
                <Route path="reports" element={<ReportsPage />} />
                <Route path="emergency" element={<EmergencyPage />} />
                <Route path="live-tracking" element={<LiveTrackingPage />} />
                <Route path="ratings" element={<RatingsPage />} />
                <Route path="driver-ratings" element={<DriverRatingPage />} />
                <Route path="passenger-ratings" element={<PassengerRatingPage />} />
                <Route path="support" element={<SupportPage />} />
                <Route path="regions" element={<RegionsPage />} />
                <Route path="main-services" element={<MainServicesPage />} />
                <Route path="services" element={<ServicesPage />} />
                <Route path="cancel-reasons" element={<CancelReasonsPage />} />
                <Route path="rating-feedback" element={<RatingFeedbackPage />} />
                <Route path="quick-chat" element={<QuickChatPage />} />
                <Route path="chat-conversations" element={<ChatConversationsPage />} />
                <Route path="faqs" element={<FAQsPage />} />
                <Route path="legal-pages" element={<LegalPagesPage />} />
                <Route path="recharge-plans" element={<RechargePlansPage />} />
                <Route path="complaints" element={<ComplaintsPage />} />
                <Route path="admin-users" element={<AdminUsersPage />} />
                <Route path="settings" element={<SettingsPage />} />
                <Route path="our-services" element={<OurServicesPage />} />
              </Route>
            </Routes>
          </Router>
        </AuthProvider>
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;
